/*!
// Tattersalls Cart
*/

$(document).ready(function() {

  new Shopify.CountryProvinceSelector('checkout-rates-country', 'checkout-rates-province', {
    hideElement: 'checkout-rates-province-container'
  });

  var $checkoutTotal = $('#checkout-total'),
      $checkoutRates = $('#checkout-rates'),
      $checkoutEstimate = $('#checkout-estimate'),
      $checkoutRatesForm = $checkoutRates.find('.checkout-rates__form'),
      $checkoutRatesResults = $checkoutRates.find('.checkout-rates__results');

  $checkoutEstimate.on('click', 'a', function(e) {
    e.preventDefault();
    $checkoutRates.show();
    $checkoutEstimate.hide();
  });

  $('#checkout-rates-submit').on('click', function(e) {
    e.preventDefault();
    getShippingRates();
  });

  // allow ENTER to submit the form
  $checkoutRates.on('keydown', 'input', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      getShippingRates();
    }
  });

  // update checkout "Total" if there are multiple rates to select
  $checkoutRatesResults.on('click', '.checkout-rates__item', function(e) {
    $checkoutRatesResults.find('.checkout-rates__item--active').removeClass('checkout-rates__item--active');
    $(e.currentTarget).addClass('checkout-rates__item--active');
    updateTotal();
  });

  var template = $('#checkout-rates-template').html();

  function updateTotal(rates) {
    var total = parseFloat($checkoutTotal.data('price'), 10);
    if (rates !== false) {
      total += parseFloat($checkoutRatesResults.find('.checkout-rates__item--active [data-price]').data('price'), 10);
    }
    $checkoutTotal.text(Shopify.formatMoney(total * 100));
  }

  function onSuccess(rates) {
    var items = [];
    $.each(rates, function(i, rate) {
      items.push({
        'name'  : rate.name,
        'price' : rate.price,
        'price_formatted' : Shopify.formatMoney(rate.price)
      });
    });
    $checkoutRatesResults.html(Mustache.render(template, { 'items': items }));
    $checkoutRatesResults.find('.checkout-rates__item').first().addClass('checkout-rates__item--active');
    $checkoutRatesForm.detach();
    updateTotal();
  }

  function onError(jqXHR, textStatus, errorThrown) {
    var msg = 'Translation missing: en.calculate_error';
    if (jqXHR.responseJSON) {
      if (jqXHR.responseJSON.country) {
        msg = 'Country ' + jqXHR.responseJSON.country;
      }
      if (jqXHR.responseJSON.province) {
        msg = 'Province ' + jqXHR.responseJSON.province;
      }
      if (jqXHR.responseJSON.zip) {
        msg = 'Postal/Zip Code ' + jqXHR.responseJSON.zip;
      }
    }
    $checkoutRatesResults.html(Mustache.render(template, { 'error': msg }));
    updateTotal(false);
  }

  function getShippingRates() {
    var params = {};
    params.country = $('#checkout-rates-country').val();
    params.province = $('#checkout-rates-province').val();
    params.zip = $('#checkout-rates-zip').val();
    $.ajax({
      type: 'POST',
      url: 'cart/prepare_shipping_rates',
      data: $.param({ shipping_address: params }),
      success: function(e) {
        $.ajax('cart/async_shipping_rates', {
          dataType: 'json',
          success: function(data, textStatus, jqXHR) {
            if (jqXHR.status === 200 && data.shipping_rates) {
              onSuccess(data.shipping_rates);
            } else {
              onError();
            }
          },
          error: onError
        });
      },
      error: onError
    });
  }

});
